import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="ranking" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            吃瓜热度榜
          </h2>
          <p className="text-sm text-foreground-500">实时更新 · 全网黑料热议排行</p>
        </div>
        <div className="max-w-3xl mx-auto space-y-3">
          {rankingItems.map((item) => (
            <button
              key={item.rank}
              onClick={() => handleScroll('#cards')}
              className="w-full flex items-center gap-4 p-4 rounded-xl bg-background-100 hover:bg-background-200/70 border border-secondary-200/40 hover:border-primary-200 transition-all duration-200 cursor-pointer text-left group"
            >
              <span
                className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center font-bold text-sm ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-secondary-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </p>
              </div>
              <div className="flex-shrink-0 flex items-center gap-2">
                {item.tag && (
                  <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                )}
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}</span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}